import { Aspect } from '@teambit/harmony';

/**
 * Main bit aspect
 */
export const BitAspect = Aspect.create({
  id: 'teambit.harmony/bit',
  dependencies: [],
});
